import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./JobsPage.css";
import Contact from "../../Components/Contact/Contact";
import Footer from "../../Components/Footer/Footer";

const JobsPage = () => {
  return (
    <>
      <Container className="jobs-container py-5">
        <Row className="mb-5">
          <Col>
            <h1 className="display-4 text-center mb-3">Career Opportunities</h1>
            <p className="lead text-center">
              Join our team of innovators and help shape the future of AI technology
            </p>
          </Col>
        </Row>

        <Row className="mb-5 justify-content-center">
          <Col md={8} className="text-center">
            <div style={{
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '12px',
              padding: '3rem 2rem',
              margin: '2rem 0'
            }}>
              <h3 style={{ marginBottom: '1rem' }}>No Open Positions</h3>
              <p style={{ color: '#888', fontSize: '1.05rem', maxWidth: '500px', margin: '0 auto' }}>
                We currently have no open positions. However, we are always interested in hearing from talented individuals who share our passion for AI, social network analysis, and human well-being.
              </p>
              <p style={{ color: '#888', fontSize: '1.05rem', marginTop: '1.5rem' }}>
                Feel free to send a speculative application to{' '}
                <a href="mailto:info@galaxyadvisors.com" style={{ color: '#4e7cff' }}>
                  info@galaxyadvisors.com
                </a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <Contact />
      <Footer />
    </>
  );
};

export default JobsPage;
